const page_schema = {
	"tiers": [
		{
			"name": "d-none",
			"type": "checkbox",
			"id": "d-nones",
			"class_name": "tags",
			"child_name": "d-none",
			"options": [
				{
					"name": "PCR & Molecular Assays",
					"id": "pcr-and-molecular-assays"
				},
				{
					"name": "PCR & qPCR",
					"id": "pcr-and-qpcr"
				},
				{
					"name": "Molecular Assays",
					"id": "molecular-assays"
				},
				{
					"name": "Femto DNA Quantification Kits",
					"id": "femto-dna-quantification-kits"
				},
				{
					"name": "DNA Standards & Ladders",
					"id": "dna-standards-and-ladders"
				},
				{
					"name": "nucleic-acid-clean-up-and-concentration",
					"id": "nucleic-acid-clean-up-and-concentration"
				}
			]
		},
	],
	"filters": [],
	"products": {
    "PolStar NGS Library Prep qPCR Premix (2X)": {
			"title": "PolStar NGS Library Prep qPCR Premix (2X)",
			"catalogNumbers": "E2070, E2071",
			"description": "The PolStar™ NGS Library Prep qPCR Premix produces auto-normalized libraries when paired with qPCR instruments that control PCR cycling of individual reactions based on fluorescence (e.g. iconPCR<sup>®</sup>).",
			"handle": "/products/polstar-ngs-library-prep-qpcr-premix-2x",
			"navigation_image": "https://stage.zymoresearch.com/cdn/shop/files/PolStar-1_600x.jpg?v=1785430586&width600",
			"generalIndex": "998",
			"id": "polstar-ngs-library-prep-qpcr-premix-2x",
			"tags": [
				"pcr-and-molecular-assays",
				"pcr-and-qpcr",
			],
			filters: []
		},
		"ZymoTaq PreMix": {
			"title": "ZymoTaq PreMix",
			"catalogNumbers": "E2003, E2004",
			"description": "ZymoTaq PreMix is supplied as a 2X concentrated “master mix” containing all the reagents needed to perform “hot start” PCR.",
			"handle": "/collections/zymotaq-polymerase/products/zymotaq-premix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2003_ZymoTaq-PreMix.jpg?v=1628532368&width=600",
			"generalIndex": "998",
			"id": "zymotaq-premix",
			"tags": [
				"pcr-and-molecular-assays",
				"pcr-and-qpcr",
			],
			filters: []
		},
		"ZymoTaq DNA Polymerase": {
			"title": "ZymoTaq DNA Polymerase",
			"catalogNumbers": "E2001, E2002",
			"description": "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR.",
			"handle": "/collections/zymotaq-polymerase/products/zymotaq-dna-polymerase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2001_ZymoTaq-Polymerase.jpg?v=1628532372&width=600",
			"generalIndex": "998",
			"id": "zymotaq-dna-polymerase",
			"tags": [
				"pcr-and-molecular-assays",
				"pcr-and-qpcr",
			],
			filters: []
		},
		"ZymoTaq qPCR Premix": {
			"title": "ZymoTaq qPCR Premix",
			"catalogNumbers": "E2054, E2055",
			"description": "ZymoTaq qPCR PreMix contains all the reagents needed to perform quantitative PCR and other molecular downstream analysis such as high-resolution melt (HRM) analysis of DNA methylation and other general real-time PCR assays.",
			"handle": "/collections/zymotaq-polymerase/products/zymotaq-qpcr-premix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2054_ZymoTaq-qPCR-Premix.jpg?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "zymotaq-qpcr-premix",
			"tags": [
				"pcr-and-molecular-assays",
				"pcr-and-qpcr",
			],
			filters: []
		},
		"OneStep PLUS qMethyl PCR Kit": {
			"title": "OneStep PLUS qMethyl PCR Kit",
			"catalogNumbers": "D5312",
			"description": "The OneStep PLUS qMethyl PCR Kit provides a simple, straightforward, and bisulfite-free procedure for the quantification of DNA methylation at custom-selected genomic regions.",
			"handle": "/products/onestep-plus-qmethyl-pcr-kit",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/files/D5312-One-STEP-PLUS-qMethyl-PCR_800x@2x.jpg",
			"generalIndex": "998",
			"id": "onestep-plus-qmethyl-pcr-kit",
			"tags": [
				"pcr-and-molecular-assays",
				"pcr-and-qpcr",
			],
			filters: []
		},
		"5-Methylcytosine dNTP Mix": {
			"title": "5-Methylcytosine dNTP Mix",
			"catalogNumbers": "D1030",
			"description": "Highly pure 5-Methylcytosine dNTP Mix that can be used to generate PCR amplicons using ZymoTaq, QuestTaq, or other DNA polymerases.",
			"handle": "/products/5-methylcytosine-dntp-mix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1030_Methylated-and-Hydroxymethylated-Nucleotides.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "5-methylcytosine-dntp-mix",
			"tags": [
				"pcr-and-molecular-assays",
				"pcr-and-qpcr",
			],
			filters: []
		},
		"5-Methyl dCTP": {
			"title": "5-Methyl dCTP",
			"catalogNumbers": "D1035",
			"description": "5-Methyl dCTP can be used in nucleotide mixtures to generate PCR amplicons using ZymoTaq, QuestTaq, or other DNA polymerases.",
			"handle": "/products/5-methyl-dctp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1035_Methylated-and-Hydroxymethylated-Nucleotides.jpg?v=1628532399&width=600",
			"generalIndex": "998",
			"id": "5-methyl-dctp",
			"tags": [
				"pcr-and-molecular-assays",
				"pcr-and-qpcr",
				// "dna-standards-and-ladders",
			],
			filters: []
		},
		"Quick SARS-CoV-2 rRT-PCR Kit": {
			"title": "Quick SARS-CoV-2 rRT-PCR Kit",
			"catalogNumbers": "R3011, R3011-1K, R3011-10K",
			"description": "The Quick SARS-CoV-2 rRT-PCR Kit is a real-time reverse transcription PCR (rRT-PCR) test for the qualitative detection of RNA from the severe acute respiratory syndrome coronavirus 2 (SARS-CoV-2) which is responsible for the coronavirus disease (COVID-19).",
			"handle": "/products/quick-sars-cov-2-rrt-pcr-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r3011-quick_sars-cov-2_rrt-pcr_kit.png?v=1628532421&width=600",
			"generalIndex": "998",
			"id": "quick-sars-cov-2-rrt-pcr-kit",
			"tags": [
				"pcr-and-molecular-assays",
			],
			filters: []
		},
		"Quick SARS-CoV-2 Multiplex Kit": {
			"title": "Quick SARS-CoV-2 Multiplex Kit",
			"catalogNumbers": "R3013, R3013-1L, R3013-10K",
			"description": "The Quick SARS-CoV-2 Multiplex Kit is a real-time reverse transcription PCR (rRT-PCR) test for the qualitative detection of RNA from the severe acute respiratory syndrome coronavirus 2 (SARS-CoV-2) which is responsible for the coronavirus disease (COVID-19).",
			"handle": "/products/quick-sars-cov-2-multiplex-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r3013-quick-sars-cov-2-multiplex-kit_png.png?v=1628532421&width=600",
			"generalIndex": "998",
			"id": "quick-sars-cov-2-multiplex-kit",
			"tags": [
				"pcr-and-molecular-assays",
			],
			filters: []
		},
		"dNTP Mix": {
			"title": "dNTP Mix",
			"catalogNumbers": "D1000, D1000-1",
			"description": "dNTP Mix is a ready-to-use, ultra pure nucleotide mix that can be used to generate PCR amplicons using ZymoTaq, QuestTaq or other DNA polymerases.",
			"handle": "/collections/dntp-solutions/products/dntp-mix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1000_dNTPs.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "dntp-mix",
			"tags": [
				"pcr-and-molecular-assays",
				"pcr-and-qpcr",
				// "dna-standards-and-ladders",
			],
			filters: []
		},
		"dCTP": {
			"title": "dCTP",
			"catalogNumbers": "D1020",
			"description": "Ultra pure dCTP can be used in nucleotide mixtures to generate PCR amplicons using ZymoTaq, QuestTaq or other DNA polymerases.",
			"handle": "/collections/dntp-solutions/products/dctp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1020_dCTP.jpg?v=1628532398&width=600",
			"generalIndex": "998",
			"id": "dctp",
			"tags": [
				"pcr-and-molecular-assays",
				"pcr-and-qpcr",
			],
			filters: []
		},
		"dATP": {
			"title": "dATP",
			"catalogNumbers": "D1005",
			"description": "Ultra pure dATP can be used in nucleotide mixtures to generate PCR amplicons using ZymoTaq, QuestTaq or other DNA polymerases.",
			"handle": "/collections/dntp-solutions/products/datp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1005_dATP.jpg?v=1628532405&width=600",
			"generalIndex": "998",
			"id": "datp",
			"tags": [
				"pcr-and-molecular-assays",
				"pcr-and-qpcr",
			],
			filters: []
		},
		"dTTP": {
			"title": "dTTP",
			"catalogNumbers": "D1010",
			"description": "Ultra pure dTTP can be used in nucleotide mixtures to generate PCR amplicons using ZymoTaq, QuestTaq or other DNA polymerases.",
			"handle": "/collections/dntp-solutions/products/dttp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1010_dTTP.jpg?v=1628532407&width=600",
			"generalIndex": "998",
			"id": "dttp",
			"tags": [
				"pcr-and-molecular-assays",
				"pcr-and-qpcr",
			],
			filters: []
		},
		"dGTP": {
			"title": "dGTP",
			"catalogNumbers": "D1015",
			"description": "Ultra pure dGTP can be used in nucleotide mixtures to generate PCR amplicons using ZymoTaq, QuestTaq or other DNA polymerases.",
			"handle": "/collections/dntp-solutions/products/dgtp",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D1015_dGTP.jpg?v=1628532393&width=600",
			"generalIndex": "998",
			"id": "dgtp",
			"tags": [
				"pcr-and-molecular-assays",
			],
			filters: []
		},
		"Femto Human DNA Quantification Kit": {
			"title": "Femto Human DNA Quantification Kit",
			"catalogNumbers": "E2005",
			"description": "The Femto Human DNA Quantification Kit can detect and quantify human DNA with high specificity and sensitivity.",
			"handle": "/collections/femto-dna-quantification-kits/products/femto-human-dna-quantification-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2005_Femto-Human-DNA-Quantification-Kit.jpg?v=1628532403&width=600",
			"generalIndex": "998",
			"id": "femto-human-dna-quantification-kit",
			"tags": [
				"pcr-and-molecular-assays",
				"molecular-assays",
				"femto-dna-quantification-kits",
			],
			filters: []
		},
		"Femto Bacterial DNA Quantification Kit": {
			"title": "Femto Bacterial DNA Quantification Kit",
			"catalogNumbers": "E2006",
			"description": "The Femto Bacterial DNA Quantification Kit can be used to detect and quantify bacterial DNA with high specificity and sensitivity.",
			"handle": "/collections/femto-dna-quantification-kits/products/femto-bacterial-dna-quantification-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2006_Femto-Bacterial-DNA-Quantification-Kit.jpg?v=1628532392&width=600",
			"generalIndex": "998",
			"id": "femto-bacterial-dna-quantification-kit",
			"tags": [
				"pcr-and-molecular-assays",
				"molecular-assays",
				"femto-dna-quantification-kits",
			],
			filters: []
		},
		"Femto Fungal DNA Quantification Kit": {
			"title": "Femto Fungal DNA Quantification Kit",
			"catalogNumbers": "E2007",
			"description": "The Femto Fungal DNA Quantification Kit can be used to detect and quantify fungal DNA with high specificity and sensitivity.",
			"handle": "/collections/femto-dna-quantification-kits/products/femto-fungal-dna-quantification-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2007_Femto-Fungal-DNA-Quantification-Kit.jpg?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "femto-fungal-dna-quantification-kit",
			"tags": [
				"pcr-and-molecular-assays",
				"molecular-assays",
				"femto-dna-quantification-kits",
			],
			filters: []
		},
		"ZR 50 bp DNA Marker": {
			"title": "ZR 50 bp DNA Marker",
			"catalogNumbers": "M5001-200, M5001-50, M5004-50",
			"description": "The ZR DNA Markers are defined DNA size fragments that encompass a range of sizes from 50 bp up to 10 kb.",
			"handle": "/products/zr-50-bp-dna-marker",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/M5001-50_ZR-50-bp-DNA-Marker-50-ug.jpg?v=1628532373&width=600",
			"generalIndex": "998",
			"id": "zr-50-bp-dna-marker",
			"tags": [
				"pcr-and-molecular-assays",
				"dna-standards-and-ladders",
			],
			filters: []
		},
		"ZR 100 bp DNA Marker": {
			"title": "ZR 100 bp DNA Marker",
			"catalogNumbers": "M5002-200, M5002-50, M5005-50",
			"description": "The ZR DNA Markers are defined DNA size fragments that encompass a range of sizes from 50 bp up to 10 kb.",
			"handle": "/products/zr-100-bp-dna-marker",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/M5002-200_ZR_20100_20bp_20DNA_20Marker_20-_20200_20ug.png?v=1628532369&width=600",
			"generalIndex": "998",
			"id": "zr-100-bp-dna-marker",
			"tags": [
				"pcr-and-molecular-assays",
				"dna-standards-and-ladders",
			],
			filters: []
		},
		"ZR 1 kb DNA Marker": {
			"title": "ZR 1 kb DNA Marker",
			"catalogNumbers": "M5003-50, M5003-200, M5006-50 ",
			"description": "The 1 kb DNA marker consists of plasmid DNA that has been digested with endonucleases to yield 10 defined fragments.",
			"handle": "/products/zr-1-kb-dna-marker",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/M5003-50_ZR-1-kb-DNA-Marker-50-ug.jpg?v=1628532358&width=600",
			"generalIndex": "998",
			"id": "zr-1-kb-dna-marker",
			"tags": [
				"pcr-and-molecular-assays",
				"dna-standards-and-ladders",
			],
			filters: []
		},
		"Universal Methylated DNA Standard": {
			"title": "Universal Methylated DNA Standard",
			"catalogNumbers": "D5011, D5012",
			"description": "The Universal Methylated DNA Standards are designed to be used as positive controls to assess the efficiency of DNA bisulfite conversion in human and mouse models.",
			"handle": "/products/universal-methylated-dna-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5011_Universal-Methylated-Human-DNA-Standard.jpg?v=1628532409&width=600",
			"generalIndex": "998",
			"id": "universal-methylated-dna-standard",
			"tags": [
				"pcr-and-molecular-assays",
				"dna-standards-and-ladders",
			],
			filters: []
		},
		"Human Methylated & Non-Methylated (WGA) DNA Set": {
			"title": "Human Methylated & Non-Methylated (WGA) DNA Set",
			"catalogNumbers": "D5013, D5013-1, D5013-2",
			"description": "The Human WGA Methylated & Non-methylated DNA Set consists of two control DNAs (non-methylated and methylated) along with a set of specifically designed primers that can be used in conjunction with the EZ DNA Methylation, EZ DNA Methylation-Gold, EZ DNA Methylation-Direct, and EZ DNA Methylation-Lightning kits from Zymo Research to assess the efficiency of bisulfite-mediated conversion of DNA.",
			"handle": "/products/human-methylated-non-methylated-wga-dna-set-dna-w-primers",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5013_Human-WGA-Methylated-and-Non-Methylated-DNA-Set.jpg?v=1628532406&width=600",
			"generalIndex": "998",
			"id": "human-methylated-non-methylated-wga-dna-set-dna-w-primers",
			"tags": [
				"pcr-and-molecular-assays",
				"dna-standards-and-ladders",
			],
			filters: []
		},
		"Human Methylated & Non-methylated DNA Set": {
			"title": "Human Methylated & Non-methylated DNA Set",
			"catalogNumbers": "D5014, D5014-1, D5014-2",
			"description": "The Human Methylated & Non-methylated DNA Set consists of two DNA controls (a CpG-methylated human DNA standard and a non-methylated human DNA standard), with a set of specifically designed primers that can be used in conjunction with the EZ DNA Methylation family of products.",
			"handle": "/products/human-methylated-non-methylated-dna-set-dna-w-primers",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5014_Human-Methylated-and-Non-Methylated-DNA-Set.jpg?v=1628532405&width=600",
			"generalIndex": "998",
			"id": "human-methylated-non-methylated-dna-set-dna-w-primers",
			"tags": [
				"pcr-and-molecular-assays",
				"dna-standards-and-ladders",
			],
			filters: []
		},
		"Bisulfite-Converted Universal Methylated Human DNA Standard": {
			"title": "Bisulfite-Converted Universal Methylated Human DNA Standard",
			"catalogNumbers": "D5015",
			"description": "The Bisulfite-Converted Universal Methylated Human DNA Standard is designed to be used as a control for DNA bisulfite conversion and downstream analyses including PCR, MSP, and other amplification-based assays.",
			"handle": "/products/bisulfite-converted-universal-methylated-human-dna-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5015_Bisulfite-Converted-Universal-Methylated-HUman-DNA-Standard.jpg?v=1628532402&width=600",
			"generalIndex": "998",
			"id": "bisulfite-converted-universal-methylated-human-dna-standard",
			"tags": [
				"pcr-and-molecular-assays",
				"dna-standards-and-ladders",
			],
			filters: []
		},
		"E. coli Non-Methylated Genomic DNA": {
			"title": "E. coli Non-Methylated Genomic DNA",
			"catalogNumbers": "D5016",
			"description": "<i>E. coli</i> non-methylated genomic DNA is from a Dam– and Dcm– strain (ER2925) of <i>E. coli</i>. It works perfectly as a negative control for DNA methylation analyses requiring DNA with absolutely no methylation.",
			"handle": "/products/e-coli-non-methylated-genomic-dna",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5016_E-Coli-Non-Methylated-Genomic-DNA.jpg?v=1628532395&width=600",
			"generalIndex": "998",
			"id": "e-coli-non-methylated-genomic-dna",
			"tags": [
				"pcr-and-molecular-assays",
				"dna-standards-and-ladders",
			],
			filters: []
		},
		"Methylated & Non-methylated pUC19 DNA Set": {
			"title": "Methylated & Non-methylated pUC19 DNA Set",
			"catalogNumbers": "D5017",
			"description": "The Methylated & Non-methylated pUC19 DNA Set consists of control DNAs and a set of specifically designed primers.",
			"handle": "/products/methylated-non-methylated-puc19-dna-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5017_Methylated-and-Non-Methylated-pUC19-DNA-Set.jpg?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "methylated-non-methylated-puc19-dna-set",
			"tags": [
				"pcr-and-molecular-assays",
				"dna-standards-and-ladders",
			],
			filters: []
		},
		"Human Matched DNA Set": {
			"title": "Human Matched DNA Set",
			"catalogNumbers": "D5018, D5018-1, D5018-2",
			"description": "The Human Matched DNA Set is a set of organ specific human genomic DNAs originating from a single individual.",
			"handle": "/products/human-matched-dna-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5018_Human-Matched-DNA-Set.jpg?v=1628532387&width=600",
			"generalIndex": "998",
			"id": "human-matched-dna-set",
			"tags": [
				"pcr-and-molecular-assays",
				"dna-standards-and-ladders",
			],
			filters: []
		},
		"Mouse 5-hmC & 5-mC DNA Set": {
			"title": "Mouse 5-hmC & 5-mC DNA Set",
			"catalogNumbers": "D5019, D5019-1, D5019-2, D5019-2, D5019-4",
			"description": "The Mouse 5-hmC & 5-mC DNA Set is a set of organ specific mouse genomic DNAs isolated from a pool of 8-10 week old Swiss Webster mice.",
			"handle": "/products/mouse-5hmc-5mc-dna-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5019_Mouse-hmC-and-5-mC-DNA.jpg?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "mouse-5hmc-5mc-dna-set",
			"tags": [
				"pcr-and-molecular-assays",
				"dna-standards-and-ladders",
			],
			filters: []
		},
		"5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set": {
			"title": "5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set",
			"catalogNumbers": "D5405",
			"description": "The 5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set is a set of three standards that are linear dsDNA at a length of 897 bp.",
			"handle": "/products/5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5405_5-mC_20_205-hmC_20DNA_20Standard_20Set.png?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set",
			"tags": [
				"pcr-and-molecular-assays",
				"dna-standards-and-ladders",
			],
			filters: []
		},
		"Zymo-Seq Methyl Spike-in Control": {
			"title": "Zymo-Seq Methyl Spike-in Control",
			"catalogNumbers": "D5500",
			"description": "Zymo-Seq Methyl Spike-in Control is comprised of six unique double-stranded synthetic amplicons (180-200 bp) with distinct sequences derived from the E. coli K12 genome, and each amplicon represents a different CpG methylation level ranging from 0% to 100%.",
			"handle": "/products/zymo-seq-methyl-spike-in-control",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/products/D5500-Zymo-Seq_Methyl_Spike-in_Control_800x@2x.jpg",
			"generalIndex": "998",
			"id": "zymo-seq-methyl-spike-in-control",
			"tags": [
				"pcr-and-molecular-assays",
				"dna-standards-and-ladders",
			],
			filters: []
		},
		"CpG Methylase (M. Sssl)": {
			"title": "CpG Methylase (M. Sssl)",
			"catalogNumbers": "E2010, E2011",
			"description": "CpG Methylase completely methylates all cytosines in double-stranded, non-methylated, and hemimethylated DNA in a 5'...CpG...3' context.",
			"handle": "/products/cpg-methylase-m-sssl",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2010_CpG-Methylase.jpg?v=1628532396&width=600",
			"generalIndex": "998",
			"id": "cpg-methylase-m-sssl",
			"tags": [
				"pcr-and-molecular-assays",
				"dna-standards-and-ladders",
			],
			filters: []
		},
		"DNA Clean & Concentrator MagBead Kit": {
			"title": "DNA Clean & Concentrator MagBead Kit",
			"catalogNumbers": "D4012",
			"description": "The DNA Clean & Concentrator MagBead Kit is magnetic bead based clean-up kit that can purify DNA from PCR, enzymatic reactions, impure extractions, and other sources.",
			"handle": "/products/dna-clean-concentrator-magbead-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4012_DNA-Clean-_-Concentrator-Magbead.jpg?v=1643046391&width=600",
			"generalIndex": "998",
			"id": "dna-clean-concentrator-magbead-kit",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"DNA Clean & Concentrator-5": {
			"title": "DNA Clean & Concentrator-5",
			"catalogNumbers": "D4003, D4004, D4013, D4014, D4003T",
			"description": "The DNA Clean & Concentrator-5 is a PCR purification kit that provides purification of up to 5 µg DNA from PCR, endonuclease digestions, DNA modification reactions, isotope/fluorescence labeling reactions, etc.",
			"handle": "/products/dna-clean-concentrator-5",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4003_DNA-Clean-and-Concentrator-5_d3bd0105-e601-4e88-a4da-04484d8bab7b.jpg?v=1628532365&width=600",
			"generalIndex": "998",
			"id": "dna-clean-concentrator-5",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"DNA Clean & Concentrator-25": {
			"title": "DNA Clean & Concentrator-25",
			"catalogNumbers": "D4033, D4034, D4005, D4006",
			"description": "The DNA Clean & Concentrator-25 (DCC-25) is a PCR purification kit designed for rapid desalting and purification of up to 25 µg DNA from enzymatic reactions (e.g., PCR), endonuclease digestions, or cell-free lysates.",
			"handle": "/products/dna-clean-concentrator-25",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4005-DNA-Clean-_-Concentrator-25.jpg?v=1628532371&width=600",
			"generalIndex": "998",
			"id": "dna-clean-concentrator-25",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"DNA Clean & Concentrator-100": {
			"title": "DNA Clean & Concentrator-100",
			"catalogNumbers": "D4029, D4030",
			"description": "The DNA Clean & Concentrator-100 (DCC-100) is a PCR purification kit designed for the rapid desalting and purification of up to 100 µg of high quality DNA from PCR, large format restriction endonuclease digestions, or cell-free lysates.",
			"handle": "/products/dna-clean-concentrator-100",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4029_DNA-Clean-and-Concentrator-100-Kit.jpg?v=1628532369&width=600",
			"generalIndex": "998",
			"id": "dna-clean-concentrator-100",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"DNA Clean & Concentrator-500": {
			"title": "DNA Clean & Concentrator-500",
			"catalogNumbers": "D4031, D4032",
			"description": "The DNA Clean & Concentrator-500 (DCC-500) is our highest capacity PCR purification kit of the DNA Clean & Concentrator products.",
			"handle": "/products/dna-clean-concentrator-500",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4031-DNA-Clean-_-Concentrator--500.jpg?v=1628532352&width=600",
			"generalIndex": "998",
			"id": "dna-clean-concentrator-500",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"ZR-96 DNA Clean-Up Kit (Shallow Well)": {
			"title": "ZR-96 DNA Clean-Up Kit (Shallow Well)",
			"catalogNumbers": "D4017, D4018",
			"description": "The ZR-96 DNA Clean-up Kit is a PCR purification kit that provides for rapid, large-scale (96-well) purification and concentration of high-quality DNA from PCR samples, endonuclease digestions, or crude plasmid preparations.",
			"handle": "/products/zr-96-dna-clean-up-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4017_ZR-96-DNA-Clean-up-Kit.jpg?v=1628532365&width=600",
			"generalIndex": "998",
			"id": "zr-96-dna-clean-up-kit",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"ZR-96 DNA Clean & Concentrator-5 (Deep Well)": {
			"title": "ZR-96 DNA Clean & Concentrator-5 (Deep Well)",
			"catalogNumbers": "D4023, D4024",
			"description": "The ZR-96 DNA Clean & Concentrator-5 Kit is a 96 well PCR purification kit that provides rapid, large-scale (96-well) purification and concentration of high-quality DNA from PCR samples, endonuclease digestions, or crude plasmid preparations.",
			"handle": "/products/zr-96-dna-clean-amp-concentrator-5-deep-well",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d4023_zr-96-dna-clean-and-concentrator-5.jpg?v=1628532420&width=600",
			"generalIndex": "998",
			"id": "zr-96-dna-clean-amp-concentrator-5-deep-well",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"ZR-96 Genomic DNA Clean & Concentrator-5 Kit": {
			"title": "ZR-96 Genomic DNA Clean & Concentrator-5 Kit",
			"catalogNumbers": "D4066, D4067",
			"description": "The ZR-96 Genomic DNA Clean & Concentrator (DCC) is a 96-well gDNA clean up kit that provides quick (~20 minutes) recovery of ultra-pure, large-sized DNA (e.g., genomic, mitochondrial, plasmid (BAC/PAC), viral, phage, (wga) DNA, etc.) from any enzymatic reaction or impure preparation (e.g., Proteinase K digestion).",
			"handle": "/products/zr-96-genomic-dna-clean-concentrator-5-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4066_ZR-96-Genomic-DNA-Clean-and-Concentrator-5-Kit.jpg?v=1628532355&width=600",
			"generalIndex": "998",
			"id": "zr-96-genomic-dna-clean-concentrator-5-kit",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"Genomic DNA Clean & Concentrator-10": {
			"title": "Genomic DNA Clean & Concentrator-10",
			"catalogNumbers": "D4010, D4011",
			"description": "The Genomic DNA Clean & Concentrator-10 (gDCC) is a gDNA clean up kit that provides quick, 5 minute recovery of ultra-pure, large-sized DNA (e.g., genomic, mitochondrial, plasmid (BAC/PAC), viral, phage, WGA DNA, etc.) from any enzymatic reaction or impure preparation (e.g., Proteinase K digestion).",
			"handle": "/products/genomic-dna-clean-concentrator-10",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4010_Genomic-DNA-Clean-and-Concentrator-10.jpg?v=1628532365&width=600",
			"generalIndex": "998",
			"id": "genomic-dna-clean-concentrator-10",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"Genomic DNA Clean & Concentrator-25": {
			"title": "Genomic DNA Clean & Concentrator-25",
			"catalogNumbers": "D4064, D4065",
			"description": "The Genomic DNA Clean & Concentrator-25 (DCC) is a spin column gDNA clean up kit that provides quick (5 minute) recovery of ultra-pure, large-sized DNA (e.g., genomic, mitochondrial, plasmid (BAC/PAC), viral, phage, (wga) DNA, etc.) from any enzymatic reaction or impure preparation (e.g., Proteinase K digestion).",
			"handle": "/products/genomic-dna-clean-concentrator-25",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4064_Genomic-DNA-Clean-and-Concentrator-25.jpg?v=1628532361&width=600",
			"generalIndex": "998",
			"id": "genomic-dna-clean-concentrator-25",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"RNA Clean & Concentrator-5": {
			"title": "RNA Clean & Concentrator-5",
			"catalogNumbers": "R1013, R1014, R1015, R1016",
			"description": "The RNA Clean & Concentrator-5 kits are RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality, RT-PCR-ready, DNA-free (R1013, R1014) RNA.",
			"handle": "/products/rna-clean-concentrator-5",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1013_RNA-Clean-and-Concentrator-5-Kit.jpg?v=1628532366&width=600",
			"generalIndex": "998",
			"id": "rna-clean-concentrator-5",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"RNA Clean & Concentrator-96": {
			"title": "RNA Clean & Concentrator-96",
			"catalogNumbers": "R1080",
			"description": "The RNA Clean & Concentrator kits are RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free (R1013, R1014) RNA.",
			"handle": "/products/rna-clean-concentrator-96",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg?v=1628532361&width=600",
			"generalIndex": "998",
			"id": "rna-clean-concentrator-96",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"RNA Clean & Concentrator-25": {
			"title": "RNA Clean & Concentrator-25",
			"catalogNumbers": "R1017, R1018",
			"description": "The RNA Clean & Concentrator-25 kits are RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality, RT-PCR-ready RNA.",
			"handle": "/products/rna-clean-concentrator-25",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1017_RNA-Clean-_-Concentrator-25.jpg?v=1628532356&width=600",
			"generalIndex": "998",
			"id": "rna-clean-concentrator-25",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"RNA Clean & Concentrator-100": {
			"title": "RNA Clean & Concentrator-100",
			"catalogNumbers": "R1019",
			"description": "The RNA Clean & Concentrator-100 kit are RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality, RT-PCR-ready RNA.",
			"handle": "/products/rna-clean-concentrator-100",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1019_RNA-Clean-_-Concentrator-100.jpg?v=1628532374&width=600",
			"generalIndex": "998",
			"id": "rna-clean-concentrator-100",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"RNA Clean & Concentrator MagBead": {
			"title": "RNA Clean & Concentrator MagBead",
			"catalogNumbers": "R1081, R1082",
			"description": "The RNA Clean & Concentrator Magbead kit provides a simple and reliable high-throughput method for the rapid preparation of high-quality, DNA-free (R1082) RNA.",
			"handle": "/products/rna-clean-concentrator-magbead",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R1082_RNA-Clean-and-Concentrator-Magbead-Kit.png?v=1628532422&width=600",
			"generalIndex": "998",
			"id": "rna-clean-concentrator-magbead",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"Select-a-Size DNA Clean & Concentrator Kit": {
			"title": "Select-a-Size DNA Clean & Concentrator Kit",
			"catalogNumbers": "D4080",
			"description": "The Select-a-Size DNA Clean & Concentrator Kit (Select-a-Size DCC) is a size selection DNA kit that provides the quickest and easiest method for purifying a desired range of DNA fragments sizes from library preps, PCR, endonuclease digestions, ligations, etc.",
			"handle": "/products/select-a-size-dna-clean-concentrator-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4080_Select-A-Size-DNA-Clean-and-Concentrator-Kit.jpg?v=1628532364&width=600",
			"generalIndex": "998",
			"id": "select-a-size-dna-clean-concentrator-kit",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"Select-a-Size DNA Clean & Concentrator MagBead Kit": {
			"title": "Select-a-Size DNA Clean & Concentrator MagBead Kit",
			"catalogNumbers": "D4045, D4046",
			"description": "The Select-a-Size DNA MagBead Kit is a size selection DNA magbead kit that provides the fastest and easiest method to purify specific ranges of DNA fragments from PCR, endonuclease digestions, ligations, library preparations, adapter removal, etc.",
			"handle": "/collections/select-a-size-dna-clean-concentrator-kits/products/select-a-size-dna-clean-concentrator-magbead-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4045-Zymoclean-Large-Fragment-DNA-Recovery-Kit.jpg?v=1628532371&width=600",
			"generalIndex": "998",
			"id": "select-a-size-dna-clean-concentrator-magbead-kit",
			"tags": [
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"Zymoclean Gel DNA Recovery Kit": {
			"title": "Zymoclean Gel DNA Recovery Kit",
			"catalogNumbers": "D4001, D4001T, D4002, D4007, D4008",
			"description": "The Zymoclean Gel DNA Recovery Kit is a gel DNA extraction kit that provides rapid purification of high quality DNA from TAE/TBE-buffered agarose gels.",
			"handle": "/products/zymoclean-gel-dna-recovery-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg?v=1628532378&width=600",
			"generalIndex": "998",
			"id": "zymoclean-gel-dna-recovery-kit",
			"tags": [
				"pcr-and-molecular-assays",
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"ZR-96 Zymoclean Gel DNA Recovery Kit": {
			"title": "ZR-96 Zymoclean Gel DNA Recovery Kit",
			"catalogNumbers": "D4021, D4022",
			"description": "The ZR-96 Zymoclean Gel DNA Recovery Kit is a 96-well gel DNA extraction kit that provides rapid purification of high quality DNA from TAE/TBE-buffered agarose gels.",
			"handle": "/products/zr-96-zymoclean-gel-dna-recovery-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4021_ZR-96-Zymoclean-Gel-DNA-Recovery-Kit.jpg?v=1628532407&width=600",
			"generalIndex": "998",
			"id": "zr-96-zymoclean-gel-dna-recovery-kit",
			"tags": [
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"Oligo Clean & Concentrator": {
			"title": "Oligo Clean & Concentrator",
			"catalogNumbers": "D4060, D4061",
			"description": "The Oligo Clean & Concentrator provides a streamlined method for efficient recovery and clean-up of DNA/RNA fragments and oligonucletides ≥ 16 nt from labeling (radioactive, biotin, DIG, etc.) and other enzymatic reactions.",
			"handle": "/collections/oligo-clean-concentrator-kits/products/oligo-clean-concentrator",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4060_Oligo-Clean-and-Concentrator-Kit_82a94808-b357-42db-9fcc-6181603dea6a.jpg?v=1628532357&width=600",
			"generalIndex": "998",
			"id": "oligo-clean-concentrator",
			"tags": [
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
		"ZR-96 Oligo Clean & Concentrator": {
			"title": "ZR-96 Oligo Clean & Concentrator",
			"catalogNumbers": "D4062, D4063",
			"description": "The Oligo Clean & Concentrator provides a streamlined method for efficient recovery and clean-up of DNA/RNA fragments and oligonucletides ≥ 16 nt from labeling (radioactive, biotin, DIG, etc.) and other enzymatic reactions.",
			"handle": "/collections/oligo-clean-concentrator-kits/products/oligo-clean-concentrator-zr96",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4062_ZR-96-Oligo-Clean-Concentrator.png?v=1628532356&width=600",
			"generalIndex": "998",
			"id": "oligo-clean-concentrator-zr96",
			"tags": [
				"nucleic-acid-clean-up-and-concentration",
			],
			filters: []
		},
	}
}